const getEmployee = async (params) => {

    try {


        const url = window.location.href;
        const isLocalhost = url.includes('localhost');
        const isSafeSakay = url.includes('safesakay.bpimsapps.com');
        const isSafeSakayBpi = url.includes('safesakay.bpims.com');
        const [, stage, , flag] = url.split('.');

        const endpoint = isLocalhost
            ? 'https://partners-api.dev.bpimsapps.com/plans/employee'
            : isSafeSakay
            ? 'https://partners-api.uat.bpimsapps.com/plans/employee'
            : isSafeSakayBpi
            ? `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
                  flag ? '' : '/partners'
              }/plans/employee`
            : `${flag ? 'https://partners-api' : 'https://fes'}.${flag ? `${stage}.` : ''}bpimsapps.com${
                  flag ? '' : '/partners'
              }/plans/employee`;

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(  
        {
                "params"  : {
                    "first_name" : params.first_name,
                    "last_name" :  params.last_name,
                    "employee_id" :  params.employee_id
                }
            }
            )
        });


        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('getEmployee api error', error);
        throw error;
    }
};

export default getEmployee;
